import {useMutation, type UseMutationOptions} from '@tanstack/react-query';
import {
	addAttributeVocabulary,
	type QueryError,
	type AddAttributeVocabularyResult,
	type AddAttributeVocabularyRequestOptions,
} from '../addAttributeVocabulary';
export * from '../addAttributeVocabulary';

export type AddAttributeVocabularyQueryOptions = Omit<
	UseMutationOptions<
		AddAttributeVocabularyResult,
		QueryError,
		AddAttributeVocabularyRequestOptions,
		AddAttributeVocabularyResult
	>,
	'mutationFn'
> & {
	mutationFn?: typeof addAttributeVocabulary;
};

/**
 * react-query wrapper for `addAttributeVocabulary`
 * @param queryKeyParams
 * @param options
 */
export const useReactQueryAddAttributeVocabulary = ({
	mutationFn = addAttributeVocabulary,
	...options
}: AddAttributeVocabularyQueryOptions = {}) =>
	useMutation<
		AddAttributeVocabularyResult,
		QueryError,
		AddAttributeVocabularyRequestOptions,
		AddAttributeVocabularyResult
	>({
		mutationFn,
		...options,
	});

export default useReactQueryAddAttributeVocabulary;
